import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconViewWeekSvg } from "./IconViewWeekSvg.mjs";
const IconViewWeek = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconViewWeekSvg, ...iconProps });
};
export {
  IconViewWeek
};
